import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueTheMask from 'vue-the-mask'
// import { VueMaskDirective } from 'v-mask'

Vue.config.productionTip = false

Vue.use(VueTheMask)
// Vue.directive('mask', mask)
// Vue.directive('mask', VueMaskDirective)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
